import React from 'react'
import allowedComponents from './allowedComponents'

const buildComponent = (
  componentName,
  componentProps = {},
  renderConditions,
  props,
  key,
  promoNames = []
) => {
  const Component = allowedComponents.find(
    component => componentName === component.displayName
  )

  let { children, ...otherProps } = componentProps

  const failedRenderConditions =
    renderConditions &&
    renderConditions.length > 0 &&
    renderConditions.some(condition => {
      const { type = 'default', name, value } = condition
      if (type === 'promos') {
        return !value.find(renderConditionPromo =>
          promoNames.includes(renderConditionPromo)
        )
      }
      return props[name] !== value
    })

  if (failedRenderConditions) {
    return null
  }

  if (Array.isArray(children)) {
    children = children.map(
      (child, idx) =>
        typeof child === 'string'
          ? buildComponent(
            'Text',
            { children: child },
            child.renderConditions,
            props,
            `Text_${idx}`,
            promoNames
          )
          : buildComponent(
            child.component,
            child.props,
            child.renderConditions,
            props,
            `${child.component}_${idx}`,
            promoNames
          )
    )
  }

  return <Component key={key} children={children} {...otherProps} />
}

export default buildComponent
